import { useTranslation } from "react-i18next";
import CommonStyles from "@components/CommonStyles";
import { hasSymptom, ISymptomSetting, toggleSymptomText } from "@base/modules/appointment/bookingCommon";

interface IProps {
  value: string;
  required: boolean;
  suggestions: ISymptomSetting[];
  onChange: (value: string) => void;
}

/** Free text plus suggestion chips that add or remove their sentence. */
export default function SymptomsField({ value, required, suggestions, onChange }: IProps) {
  //! state
  const { t } = useTranslation();

  //! render
  return (
    <div className="flex flex-col gap-2">
      <span className="text-common-maintext text-sm font-medium font-['Inter']">
        {t("booking.symptoms")} {required ? <span className="text-common-red500">*</span> : null}
      </span>

      <CommonStyles.TextAreaUI
        variant="filled"
        rows={3}
        maxLength={1000}
        value={value}
        placeholder={t("booking.symptomsPlaceholder")}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value)}
      />

      {suggestions.length ? (
        <div className="flex flex-wrap gap-2">
          {suggestions.map((symptom, index) => {
            const text = symptom.description || symptom.symptom_name || "";
            const isActive = hasSymptom(value, text);

            return (
              <button
                type="button"
                key={`${symptom.symptom_name}-${index}`}
                onClick={() => onChange(toggleSymptomText(value, text))}
                className={`px-3 py-1 rounded-full border text-xs font-['Inter'] ${
                  isActive
                    ? "border-common-primary bg-common-primary100 text-common-primary"
                    : "border-common-divider bg-common-white text-common-maintext"
                }`}
              >
                {symptom.symptom_name}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
